export const usePrintPage = () => {
    const snippetsStore = useSnippetsStore();
    const snippets = snippetsStore.snippets;
    const route = useRoute();

    // Check if current page is terms and conditions page
    const isTermsAndConditionsPage = computed(() => {
        const termsUrl = (snippets as any)['headless.footer.termsAndConditionsUrl'];
        const currentPath = route.path;

        if (!termsUrl) return false;

        // Remove leading slash and compare
        const cleanTermsUrl = termsUrl.replace(/^\//, '');
        const cleanCurrentPath = currentPath.replace(/^\//, '');

        return cleanCurrentPath === cleanTermsUrl || cleanCurrentPath.includes(cleanTermsUrl);
    });

    // Print function
    const printPage = () => {
        window.print();
    };

    return {
        isTermsAndConditionsPage,
        printPage,
    };
};
